import React, { RefObject, useEffect, useRef, useState } from 'react';
import { Button, Menu, MenuItem, Box, Typography, Chip } from '@mui/material';
import { Check } from '@mui/icons-material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import { FilterDataValue } from 'types/types';

type TechnologyProps = {
  technology: string;
  technologyBandsList: FilterDataValue[];
  handleBandToggle: (bandFilterItem: FilterDataValue) => void;
};

const TechnologyBandSelector: React.FC<TechnologyProps> = ({
  technology,
  technologyBandsList,
  handleBandToggle,
}) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [internalSelectedBands, setInternalSelectedBands] = useState<string[]>(
    technologyBandsList.map((s) => s.id!) || []
  );

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleSelect = (bandFilterItem: FilterDataValue) => {
    handleBandToggle(bandFilterItem);
    setInternalSelectedBands((prev) =>
      prev.includes(bandFilterItem.id!)
        ? prev.filter((item) => item !== bandFilterItem.id!)
        : [...prev, bandFilterItem.id!]
    );
  };

  return (
    <Box>
      <Button
        onClick={handleClick}
        className={`band-button big-button ${
          anchorEl ? 'selected-band-button' : ''
        }`}
      >
        <Chip label={internalSelectedBands.length} className="band-chip" />
        {technology}
        {anchorEl ? (
          <KeyboardArrowUpIcon className="arrow-icon" />
        ) : (
          <KeyboardArrowDownIcon className="arrow-icon" />
        )}
      </Button>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        slotProps={{
          paper: {
            className: 'band-menu',
          },
        }}
        MenuListProps={{
          sx: {
            padding: 0,
          },
        }}
      >
        {technologyBandsList.map((bandFilterItem) => (
          <MenuItem
            key={bandFilterItem.id}
            onClick={() => handleSelect(bandFilterItem)}
            sx={{
              backgroundColor: bandFilterItem.contextInfo["CELL_BAND_NAME_COLOR"],
              color: bandFilterItem.contextInfo["CELL_BAND_NAME_TEXTCOLOR"],
              '&:hover': {
                backgroundColor: bandFilterItem.contextInfo["CELL_BAND_NAME_COLOR"],
                opacity: '0.8',
              },
            }}
          >
            <Box className="band-item">
              <Typography sx={{ flexGrow: 1 }}>{bandFilterItem.name}</Typography>
              {internalSelectedBands.includes(bandFilterItem.id!) && (
                <Check sx={{ ml: 1 }} />
              )}
            </Box>
          </MenuItem>
        ))}
      </Menu>
    </Box>
  );
};

export default TechnologyBandSelector;
